import {
  useCreate,
  useOutsourceStudio,
  useUpdate,
} from 'scenes/Gallery/GalleryPage/OutsourceStudios/data';

import OutsourceStudioForm from './OutsourceStudioForm';

export const CreateOutsourceStudio = ({
  open,
  onSubmit,
  onClose,
  onExited,
}) => {
  const [createOutsourceStudio, { isLoading: isCreating }] = useCreate();
  const handleSubmit = async (values) => {
    const response = await createOutsourceStudio(values);

    onSubmit(response);
  };
  return (
    <OutsourceStudioForm
      title={'Add Outsource Studio'}
      open={open}
      onSubmit={handleSubmit}
      onClose={onClose}
      onExited={onExited}
      loading={isCreating}
    />
  );
};

export const UpdateOutSourceStudio = ({
  id,
  open,
  onClose,
  onSubmit,
  onExited,
}) => {
  const [updateOutSourceStudio, { isLoading: isUpdating }] = useUpdate();
  const { data, isLoading } = useOutsourceStudio({ id });
  const handleSubmit = async (values) => {
    await updateOutSourceStudio(values);
    onSubmit();
  };
  return (
    <OutsourceStudioForm
      title={'Edit Outsource Studio'}
      open={open}
      initialValues={data}
      active={!!data}
      loading={isLoading || isUpdating}
      onClose={onClose}
      onExited={onExited}
      onSubmit={handleSubmit}
    />
  );
};
